import React from 'react'
import TestsPanel from './TestsPanel'

function WorkSurface () {
  return <TestsPanel />
}

export default WorkSurface
